/**
 * Nastavení — osobní stránka přihlášeného uživatele.
 * Změna hesla + návod na přidání aplikace na plochu (PWA).
 */
import { openChangePasswordModal } from '../components/change-password-modal.js';
import { getProfile } from '../lib/auth.js';

function esc(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export async function renderUcet(container) {
    const profile = await getProfile();

    container.innerHTML = `
        <div class="ucet-wrap">
            <section class="ucet-card">
                <h3>Účet</h3>
                <p class="ucet-line"><span class="ucet-k">Jméno</span>${esc(profile?.name || '—')}</p>
                <p class="ucet-line"><span class="ucet-k">E-mail</span>${esc(profile?.email || '—')}</p>
                <p class="ucet-line"><span class="ucet-k">Verze</span>${esc(typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '—')}</p>
            </section>

            <section class="ucet-card">
                <h3>Heslo</h3>
                <p class="ucet-note">Tady si kdykoliv změníš přihlašovací heslo do aplikace.</p>
                <button class="btn btn-primary" id="ucet-change-pass">Změnit heslo</button>
            </section>

            <section class="ucet-card">
                <h3>Přidat aplikaci na plochu telefonu</h3>
                <p class="ucet-note">
                    Aplikaci si můžeš přidat na plochu jako ikonu — pak se spouští
                    na celou obrazovku jako běžná aplikace, bez lišty prohlížeče.
                </p>
                <div class="ucet-pwa">
                    <strong>iPhone — Safari</strong>
                    <ol>
                        <li>Otevři aplikaci v prohlížeči Safari</li>
                        <li>Klepni na <strong>Sdílet</strong> (čtvereček se šipkou nahoru)</li>
                        <li>Zvol <strong>Přidat na plochu</strong></li>
                    </ol>
                </div>
                <div class="ucet-pwa">
                    <strong>Android — Chrome</strong>
                    <ol>
                        <li>Otevři aplikaci v prohlížeči Chrome</li>
                        <li>Klepni na menu <strong>⋮</strong> vpravo nahoře</li>
                        <li>Zvol <strong>Přidat na plochu</strong> / <strong>Nainstalovat aplikaci</strong></li>
                    </ol>
                </div>
            </section>
        </div>
    `;

    container.querySelector('#ucet-change-pass')
        .addEventListener('click', () => openChangePasswordModal());
}
